import { Box, Tab, Tabs, useTheme } from '@mui/material'
import * as React from 'react'
import { useState } from 'react'
import CodeBlock from './CodeBlock'
import Compare from '../Compare.txt'
import PercentWeightLoss from '../PercentWeightLoss.txt'
import { overrideTabColour } from './SharedFns'

export function EndpointExamples() {
  const theme = useTheme()
  const [value, setValue] = useState(0)
  return (
    <Box sx={{ display: 'flex', width: 1, mt: 1, minHeight: 200 }}>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={(_, newVal) => setValue(newVal)}
        sx={overrideTabColour(theme)}
      >
        <Tab label="> OR <" />
        <Tab
          label="% weight loss"
          sx={{ color: theme.palette.info + '!important' }}
        />
      </Tabs>
      {value === 0 && <CodeBlock file={Compare} />}
      {value === 1 && <CodeBlock file={PercentWeightLoss} />}
    </Box>
  )
}

export default EndpointExamples
